import React from 'react';
import styled, { css } from 'styled-components';
import { minBreakpointQuery, brandColours } from '../styles';
import { Svg } from './ui';
import ImageContent from './ImageContent';
import stitchPatternBg from '../images/stitch-pattern-bg.svg';
import timelineArrowIcon from '../images/timeline-arrow-icon.inline.svg';

const StyledTimeline = styled.section`
  padding: 10px 0;
  background: url(${stitchPatternBg}) 0 0 / 160px 160px;
  border-top: 2px solid ${brandColours.quaternary};
  border-bottom: 2px solid ${brandColours.quaternary};
`;

const StyledArrow = styled(Svg)`
  margin: auto;
  height: 100px;
  width: 100%;

  ${minBreakpointQuery.small`
    height: 140px;
  `}

  ${minBreakpointQuery.large`
    height: 180px;
  `}

  ${({ flip }) => {
    if (flip) {
      return css`
        transform: scale(-1, 1);
      `;
    }
  }}
`;

const Timeline = ({ events }) => (
  <StyledTimeline>
    {events.map(({ id, image, year, heading, text }, i) => {
      const eventNum = i + 1;
      const flip = eventNum % 2;

      return (
        <>
          <ImageContent
            key={id}
            image={image}
            year={year}
            heading={heading}
            text={text}
            flip={flip}
            isTimelineEvent={true}
          />
          {eventNum < events.length && (
            <StyledArrow image={timelineArrowIcon} flip={flip} />
          )}
        </>
      );
    })}
  </StyledTimeline>
);

export default Timeline;
